import { useState, useEffect } from 'react';
import { TBillingProListingFeeItem, TGetPaymentBillingProListingFeeList } from 'types/financials';
import { getPaymentBillingProListingFeeList, getPaymentBillingPracticeProListingFeeList } from 'api/financials';

const usePaymentBillingProListingFeeList = (
    param?: Partial<TGetPaymentBillingProListingFeeList>,
    isPractice = false,
): [
    TBillingProListingFeeItem[] | undefined,
    number,
    boolean,
    (param?: Partial<TGetPaymentBillingProListingFeeList>) => void,
] => {
    const [data, setData] = useState<TBillingProListingFeeItem[]>();
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchData = async (para: Partial<TGetPaymentBillingProListingFeeList> = {}) => {
        try {
            setLoading(true);
            const request = isPractice
                ? getPaymentBillingPracticeProListingFeeList
                : getPaymentBillingProListingFeeList;
            const res = await request({
                current: 1,
                size: 10,
                ...para,
            });
            if (!res.error) {
                const list = res.data?.data?.records || [];
                const amount = res.data?.data?.total;
                setTotal(amount || 0);
                setData(list);
            }
        } catch (err) {
            console.error('Payment list fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(param);
    }, []);

    return [data, total, loading, fetchData];
};

export default usePaymentBillingProListingFeeList;
